module.exports = __webpack_public_path__ + "static/world_map-471ae372c1dac2bdc6c1bb16b46880de.png";